import ProviderServiceV3 from "@/services/v3/provider.service";
import ProviderService from "@/services/ProviderService";
import ErrorHandlerService from "@/services/ErrorHandlerService";

export const emptySellersFilters = () => ({
    name: "",
    status: undefined,
    state: undefined,
    city: "",
    phone: "",
    homologation_status: undefined,
});

export const HOMOLOGATION_PENDING = "PENDING";

export const sellersListMixin = {
    data() {
        return {
            svc: new ProviderServiceV3(),
            prov_svc: new ProviderService(),
            isDesktop: window.innerWidth >= 720,
            showTotalizadores: true,
            loading: false,
            filters: emptySellersFilters(),
            appliedFilters: emptySellersFilters(),
            withOrders: false,
            withOffer: false,
            totalSellers: 0,
            totalOrders: 0,
            totalOffers: 0,
            // Card "Pendentes de homologação": só a aba de fornecedores liga (meta.pending_homologation).
            showHomologationCard: false,
            totalPendingHomologation: 0,
            states: [],
            pagination: {
                current: 1,
                pageSize: 50,
                total: 0,
                showSizeChanger: true,
                pageSizeOptions: ["20", "50", "100"],
                locale: { items_per_page: "/ página" },
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`,
            },
        };
    },
    computed: {
        selectedCardKeys() {
            return [
                this.withOrders && "orders",
                this.withOffer && "offers",
                this.showHomologationCard &&
                    this.appliedFilters.homologation_status === HOMOLOGATION_PENDING &&
                    "pending_homologation",
            ].filter(Boolean);
        },
        dashboardCards() {
            const cards = [
                {
                    key: "total",
                    title: "Total",
                    icon: "groups",
                    value: this.totalSellers,
                    borderColor: "#FF5722",
                },
                {
                    key: "orders",
                    title: "Com Pedidos",
                    icon: "shopping_cart",
                    value: this.totalOrders,
                    valueColor: "#30aa4c",
                    borderColor: "#30aa4c",
                    suffix: `(${this.percentOfSellers(this.totalOrders)}%)`,
                },
                {
                    key: "offers",
                    title: "Com Digitações",
                    icon: "edit_note",
                    value: this.totalOffers,
                    valueColor: "#4f4ff7",
                    borderColor: "#4f4ff7",
                    suffix: `(${this.percentOfSellers(this.totalOffers)}%)`,
                },
            ];
            if (this.showHomologationCard) {
                cards.push({
                    key: "pending_homologation",
                    title: "Pendentes de homologação",
                    icon: "pending_actions",
                    value: this.totalPendingHomologation,
                    valueColor: "#fa8c16",
                    borderColor: "#fa8c16",
                    suffix: `(${this.percentOfSellers(this.totalPendingHomologation)}%)`,
                });
            }
            return cards;
        },
    },
    methods: {
        buildParams(page) {
            return {
                page,
                page_size: this.pagination.pageSize,
                name: this.appliedFilters.name,
                status: this.appliedFilters.status || null,
                state: this.appliedFilters.state || null,
                with_order: this.withOrders ? 1 : 0,
                with_offer: this.withOffer ? 1 : 0,
            };
        },
        readMeta(meta = {}) {
            this.pagination.total = meta.total || 0;
            this.totalSellers = meta.total_sellers || 0;
            this.totalOrders = meta.with_orders || 0;
            this.totalOffers = meta.with_offers || 0;
        },
        percentOfSellers(value) {
            if (!this.totalSellers) return "0,00";
            return ((value / this.totalSellers) * 100).toFixed(2).replace(".", ",");
        },
        aplicarFiltroRapido(key) {
            if (key === "total") {
                this.withOrders = false;
                this.withOffer = false;
                if (this.showHomologationCard) this.setHomologationFilter(undefined);
            } else if (key === "pending_homologation") {
                const active = this.appliedFilters.homologation_status === HOMOLOGATION_PENDING;
                this.setHomologationFilter(active ? undefined : HOMOLOGATION_PENDING);
            } else if (key === "orders") {
                this.withOrders = !this.withOrders;
            } else if (key === "offers") {
                this.withOffer = !this.withOffer;
            }
            this.loadData(1);
        },
        // O card de pendentes usa o mesmo filtro do select "Homologação", mantendo os dois em sincronia.
        setHomologationFilter(value) {
            this.filters = { ...this.filters, homologation_status: value };
            this.appliedFilters = { ...this.appliedFilters, homologation_status: value };
        },
        filtrar() {
            this.appliedFilters = { ...this.filters };
            this.loadData(1);
        },
        handleLimparFiltros() {
            this.filters = emptySellersFilters();
            this.appliedFilters = emptySellersFilters();
            this.withOrders = false;
            this.withOffer = false;
            this.resetSort();
            this.loadData(1);
        },
        resetSort() {},
        formatNumber(number) {
            if (!number) return null;
            number = number.replace("+", "").replace("(", "").replace(")", "").replace("-", "");
            if (number[0] + "" + number[1] != "55") number = "55" + number;
            return number;
        },
        getParticipation(seller) {
            const client = seller.clients && seller.clients[0];
            return client && client.pivot ? client.pivot.participation : 0;
        },
        participationColor(value) {
            if (value <= 0.3) return "red";
            if (value >= 0.7) return "green";
            return "orange";
        },
        rating(seller) {
            return seller.review ? seller.review + ".0" : "--";
        },
        loadStates() {
            this.svc
                .States()
                .then(({ data }) => {
                    this.states = (data || []).map((s) => ({ value: s.est_sigla, label: s.est_nome }));
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        handleResize() {
            this.isDesktop = window.innerWidth >= 720;
        },
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
        this.loadStates();
        this.loadData(1);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    },
};
